import { BeamButton } from "../../landing-page/components/BeamButton";
import useTranslation from "../../client/hooks/useTranslation";

export default function MarketingHero({ h1, subtitle }: { h1: string; subtitle: string }) {
  const t = useTranslation();
  return (
    <section className="relative overflow-hidden px-6 pt-28 pb-16 sm:pt-36 sm:pb-24 lg:px-8">
      <div className="pointer-events-none absolute top-0 left-1/2 -translate-x-1/2 h-72 w-[700px] rounded-full bg-primary/10 blur-3xl" />
      <div className="relative z-10 mx-auto max-w-4xl text-center">
        <h1 className="font-display text-4xl font-bold tracking-tight text-foreground sm:text-5xl md:text-6xl">
          {h1}
        </h1>
        <p className="mt-6 text-lg leading-8 text-muted-foreground max-w-2xl mx-auto">
          {subtitle}
        </p>
        <div className="mt-10 flex justify-center">
          <BeamButton size="lg" showArrow className="px-6">
            {t.marketing.common.ctaFinalButton}
          </BeamButton>
        </div>
      </div>
    </section>
  );
}
